module.exports = __webpack_public_path__ + "img/shield.c3875e12.svg";